// 当雷达数据列表发生变化时的事件
export const LIDAR_DATA_LIST_CHANGED = 'onLidarDataListChanged'

// 选中雷达数据
export const LIDAR_DATA_SELECT = 'onLidarDataSelect'

// 插入雷达数据
export const LIDAR_DATA_INSERT = 'onLidarDataInsert'

// 追加雷达数据
export const LIDAR_DATA_APPEND = 'onLidarDataAppend'

// 风廓线雷达数据列表发生变化时的事件
export const WIND_PROFILE_DATA_LIST_CHANGED = 'onWindProfileDataListChanged'

// 选中风廓线雷达数据
export const WIND_PROFILE_DATA_SELECT = 'onWindProfileDataSelect'

// 插入风廓线雷达数据
export const WIND_PROFILE_DATA_INSERT = 'onWindProfileDataInsert'

// 追加风廓线雷达数据
export const WIND_PROFILE_DATA_APPEND = 'onWindProfileDataAppend'



// WEBPACK FOOTER //
// ./src/components/Data/ChartWrapper/EventKeys.js